import { takeEvery } from 'redux-saga/effects';
import { GET_ALL_SYSTEM_PROPERTY } from './system-property.action';
import { getAllSystemPropertySaga } from './system-property.saga';

export const systemPropertySaga = [
  takeEvery(GET_ALL_SYSTEM_PROPERTY, getAllSystemPropertySaga),
];
